<template>
  <div class="static service">
	<div class="logo-left">
	  <a href="/storesafe" target="_parent">
		<img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
	  </a>
	</div>
	<h1>{{ $t('service.page_title') }}</h1>
  </div>

  	<div class="static-grey">
	  {{ $t('service.intro_text') }}
	</div>
	<div class="static-white">
	  <div class="static-split">
		  <div class="split-image">
			<img src="@/assets/images/service_pro-cart-ultra.jpg" alt="Pro Cart Ultra">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('service.pro_cart_ultra') }}</h2>
			<p>{{ $t('service.the_pro_cart_ultra_provides_the_ability_') }}</p>
			<a href="https://www.cambro.com/Products/insulated-food-transport/electric-food-transport-carts/the-pro-cart-ultra-pan-carriers/" target="_blank" class="learn-more">
			<button @mouseover="isHovered = true" 
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-testimonial">
		   <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		   <div class="testimonial-quote">{{ $t('service.the_way_pro_cart_ultra_units_are_designe')}}&quot;</div>
		   <div class="testimonial-name"><a href="https://blog.cambro.com/2023/11/08/why-cambro-hot-boxes-are-unmatched/" target="_blank">{{ $t('service.justin_webb_food_operations_director_at_')}}</a></div>
	   </div>
	   
	  <div class="static-split red-line">
		  <div class="split-image">
			<img src="@/assets/images/service_ultra-pan-carrier.jpg" alt="Ultra Pan Carrier">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('service.ultra_pan_carrier') }}</h2>
			<p>{{ $t('service.a_nonelectric_passive_holding_solution_k') }}</p>
			<a href="https://www.cambro.com/Products/insulated-food-transport/insulated-front-loading-food-pan-carriers/upc300/" target="_blank" class="learn-more">
			<button @mouseover="isHovered = true" 
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-testimonial">
		  <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		  <div class="testimonial-quote">{{ $t('service.in_addition_to_our_delicious_and_guarant')}}&quot;</div>
		  <div class="testimonial-name"><a href="https://blog.cambro.com/2023/11/08/why-cambro-hot-boxes-are-unmatched/" target="_blank">{{ $t('service.joe_feran_owner_of_lobster_brothers_seaf')}}</a></div>
	  </div>
	  
	 <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_gobox.jpg" alt="GoBox">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('service.gobox') }}</h2>
		   <p>{{ $t('service.cater_compact_with_cambros_most_lightwei') }}</p>
		   <a href="https://www.cambro.com/Products/insulated-food-transport/cam-gobox--food-transporters/cam-gobox-accessories/temperature-maintenance-tools/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
	  </div>
	  
	  <div class="static-testimonial">
		<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		<div class="testimonial-quote">{{ $t('service.we_use_a_lot_of_cambro_products_the_most')}}&quot;</div>
		<div class="testimonial-name"><a href="https://blog.cambro.com/2024/03/20/cambros-business-of-the-week-831-catering/" target="_blank">{{ $t('service.831_catering')}}</a></div>
	  </div>
		
	   <div class="static-split red-line">
		   <div class="split-image">
			 <img src="@/assets/images/service_camchiller.jpg" alt="CamChiller & CamWarmer">
		   </div>
		   <div class="split-content">
			 <h2>{{ $t('service.passive_holding_accessories') }}</h2>
			 <p>{{ $t('service.pair_any_passive_holding_unit_with_a_cam') }}</p>
			 <a href="https://www.cambro.com/Products/insulated-food-transport/cam-gobox--food-transporters/cam-gobox-accessories/temperature-maintenance-tools/" target="_blank" class="learn-more">
			 <button @mouseover="isHovered = true" 
					 @mouseleave="isHovered = false"
					 :class="{ 'hovered': isHovered }">
			   {{ $t('receiving.learn_more_btn')}}
			 </button></a>
		   </div>
		</div>

	  <div class="static-testimonial">
		<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		<div class="testimonial-quote">{{ $t('service.when_being_asked_which_cambro_product_he')}}.&quot;</div>
		<div class="testimonial-name"><a href="https://blog.cambro.com/2023/08/04/cambros-business-of-the-week-rgkkitchen/" target="_blank">{{ $t('service.rae_gablerkirbos_cofounder_of_rgkkitchen')}}</a></div>
	  </div>
		
	   <div class="static-split red-line">
		   <div class="split-image">
			 <img src="@/assets/images/service_gobags.jpg" alt="GoBags / Pizza Bags">
		   </div>
		   <div class="split-content">
			 <h2>{{ $t('service.gobags_pizza_bags') }}</h2>
			 <p>{{ $t('service.gobags_offer_high_density_insulation_t') }}</p>
			 <a href="https://www.cambro.com/Products/insulated-food-transport/gobags/" target="_blank" class="learn-more">
			 <button @mouseover="isHovered = true" 
					 @mouseleave="isHovered = false"
					 :class="{ 'hovered': isHovered }">
			   {{ $t('receiving.learn_more_btn')}}
			 </button></a>
		   </div>
		</div>
	   
	   <div class="static-testimonial">
		  <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		  <div class="testimonial-quote">We did a catering order with 10 pizzas. We loaded up those 5-pizza GoBags, drove them over to the catering spot, and I just noticed how much hotter and better the pizza was.&quot;</div>
		  <div class="testimonial-pic"><img src="@/assets/images/prep_testimonial-1.png" /></div>
		  <div class="testimonial-name"><a href="https://blog.cambro.com/2023/01/25/righteous-slice/" target="_blank">{{ $t('bill_crawford_founder_of_righteous_slice')}}</a></div>
	  </div>
	  
	  <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_griplid.jpg" alt="GripLids">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('service.griplid') }}</h2>
		   <p>{{ $t('service.unbeatable_protection_against_spills_and') }}</p>
		   <a href="https://www.cambro.com/Products/food-pans-and-lids/food-pans/camwear-griplids/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
	    </div>
		 
		 <div class="static-testimonial">
			<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
			<div class="testimonial-quote">{{ $t('service.lately_we_started_using_the_griplids_wit')}}&quot;</div>
			<div class="testimonial-pic"><img src="@/assets/images/service_testimonial-1.jpg" /></div>
			<div class="testimonial-name"><a href="https://blog.cambro.com/2021/10/25/cambros-business-of-the-week-coronado-kitchen/" target="_blank">{{ $t('service.tyler_tragemann_chef_and_owner_of_corona')}}</a></div>
		</div>
		
 	   <!-- <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_meal-delivery-carts.jpg" alt="Meal Delivery Carts">
		 </div>
		 <div class="split-content">
		   <h2>Meal Delivery Carts</h2>
		   <p>Designed for healthcare operations, the Meal Delivery Cart is manufactured with thick CFC-free foam insulation to preserve optimal meal temperatures, and is rust, dent, crack, chip, and break resistant to protect the contents on your trays.</p>
		   <a href="https://www.cambro.com/Products/insulated-food-transport/meal-delivery-carts/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 Learn More
		   </button></a>
		 </div>
		</div> -->
		 
		 <!-- <div class="static-testimonial">
			<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
			<div class="testimonial-quote">We looked at the Cambro carts and we decided to go with [the 10 Tray Meal Delivery Cart] because they were more durable. They weren’t like stainless steel where constantly we had to make sure they’re shining. They’re easy to clean and maintain, a lot easier than the bigger, bulky trucks. Pushing them around in the hallway is easier on my staff, it’s not a strain on their backs or anything.&quot;</div>
			<div class="testimonial-name"><a href="https://blog.cambro.com/2022/05/09/your-hospital-will-want-cambro-meal-delivery-carts-stat/" target="_blank">Nick McElroy, Food Service Manager at South Shore University Hospital</a></div>
		</div> -->
		
		<!-- <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_versa-food-bar.jpg" alt="Versa Food Bar">
		 </div>
		 <div class="split-content">
		   <h2>Versa Food Bar</h2>
		   <p>Maximize space, improve traffic, or add merchandising opportunities with this non-electric mobile vending solution, holding cold Grab n’ Go items such as salads, sandwiches, beverages, fruits and vegetables, and snacks safely for 4+ hours.</p>
		   <a href="https://www.cambro.com/Products/food-and-salad-bars/food-and-salad-bars/versa-food-bar/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 Learn More
		   </button></a>
		 </div>
		</div> -->
		 
		 <!-- <div class="static-testimonial">
			<div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
			<div class="testimonial-quote">In the morning, these carts are filled with different breakfast items and wheeled to separate halls. We are able to feed all the children in about 15 minutes.&quot;</div>
			<div class="testimonial-name"><a href="https://blog.cambro.com/2021/10/12/lunch-on-the-go-thinking-outside-the-cafeteria/" target="_blank">Carolyn Barnes, Foodservice Director of Newberry County School District</a></div>
		</div> -->
		
		<!-- <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_coldfest.jpg" alt="Coldfest Containers">
		 </div>
		 <div class="split-content">
		   <h2>Coldfest Containers</h2>
		   <p>Keep ingredients, condiments, and creamers chilled at food-safe temperature during self-service and caterings, without ice.</p>
		   <a href="https://www.cambro.com/Products/food-storage/coldfest-containers/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 Learn More
		   </button></a>
		 </div>
		</div> -->
		
		<div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/service_serving-spoons.jpg" alt="Serving Spoons, Tongs, and Ladles">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('service.serving_spoons_tongs_and_ladles') }}</h2>
		   <p>{{ $t('service.these_utensils_are_made_from_break_and_h') }}</p>
		   <a href="https://www.cambro.com/Products/display-and-serving/ladels-spoons-and-tongs/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
		</div>
		
		<div class="sub-white">
			<h1>{{ $t('receiving.other_resources_title') }}</h1>
			<div class="home-categories">
				<a href="/storesafe/receiving" target="_parent" class="home-cat"><div class="cat-receiving"></div></a>
				<a href="/storesafe/storage" target="_parent" class="home-cat"><div class="cat-storage"></div></a>
				<a href="/storesafe/preparation" target="_parent" class="home-cat"><div class="cat-prep"></div></a>
				<a href="#" class="home-cat dimmed"><div class="cat-service"></div></a>
				<a href="/storesafe/warewashing" target="_parent" class="home-cat"><div class="cat-warewashing"></div></a>
			</div>
		</div>
	   
	</div>
  
  
  </template>
  
